import * as TYPES from '../types';

// state
const initialState = {
    pagination: {
        totalCount: 0,
        activePage: 1,
        totalItemsCount: 10,
    },
    search: '',
    daily_movement: [],
    movement: [],
    single_daily_movement: {},
    sort_order_name: null,
    sort_order_direction: null,
    loading: false,
    modalLoading: false,
    lotno_modal: false,
    selected_products: [],
    date_from: new Date(),
    date_to: new Date(),
    movement_option: { value: 'all', label: 'All' },
    movement_options: [
        { value: 'all', label: 'All' },
        { value: 'pos', label: 'POS' },
        { value: 'sales order', label: 'Sales Order' },
        { value: 'delivery', label: 'Delivery' },
    ],
    isSearchable: true,
};

const dailyMovementReducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPES.GET_DAILY_MOVEMENT_DATA:
            return {
                ...state,
                daily_movement: action.payload.daily_movement,
                pagination: action.payload.pagination,
            };
        case TYPES.SEARCH_INPUT:
            return {
                ...state,
                search: action.payload,
            };
        case TYPES.SORT_BY_COLUMN:
            return {
                ...state,
                sort_order_name: action.payload.sort_order_name,
                sort_order_direction: action.payload.sort_order_direction,
            };
        case TYPES.SET_MODAL:
            return {
                ...state,
                [action.payload.modal]: action.payload.status,
            };
        case TYPES.SET_MODAL_LOADING: // New case for modal loading
            return {
                ...state,
                modalLoading: action.payload,
            };
        case TYPES.DAILY_MOVEMENT_VIEW:
            return {
                ...state,
                daily_movement: action.payload.daily_movement,
            };
        case TYPES.PRODUCTS_DAILY_MOVEMENT:
            return {
                ...state,
                selected_products: action.payload,
            };

        case TYPES.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case TYPES.DATE_FILTER_INPUT:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        case TYPES.DAILY_MOVEMENT_DATE_INPUT_CLEAR:
            return {
                ...state,
                date_from: new Date(),
                date_to: new Date(),
                date_filter: false,
                display_tab: { ...state.display_tab, [action.payload]: true },
            };
        case TYPES.DAILY_MOVEMENT_CHECKER:
            return {
                ...state,
                movement: action.payload.movement,
            };
        case TYPES.HANDLE_MOVEMENT_OPTIONS:
            return {
                ...state,
                movement_option: action.payload,
            };
        default:
            return state;
            break;
    }
};

export default dailyMovementReducer;
